export const INITIAL_INDEX = 0;
export const EMPTY_LENGTH = 0;
export const NOT_FOUND_INDEX = -1;
export const ADJACENT_OFFSET = 1;
export const SINGLE_SELECTION = 1;
export const DRAWER_Z_INDEX_OFFSET = 2;
